export default class Modal{
	constructor(){}
	initModal(images, initialPosition){
		const modal = document.querySelector(".wedding-gallery__modal");
		const viewport = modal.querySelector(".wedding-gallery__modal__viewport");
		const pager = modal.querySelector(".wedding-gallery__modal__pager");
		const close = modal.querySelector(".wedding-gallery__modal__close");
		const prev = modal.querySelector(".wedding-gallery__modal__prev");
		const next = modal.querySelector(".wedding-gallery__modal__next");
		const max = images.length;
		const pagerAreaSize1 = 5;
		const pagerAreaSize2 = pagerAreaSize1+2;
		let position = initialPosition ? initialPosition : 0;

		pager.innerHTML = "";
		viewport.innerHTML = "";

		images.forEach((image,index)=>{
			const slide = document.createElement("div");
			const slideimg = document.createElement("img");
			const load = document.createElement("span");
			const page = document.createElement("div");
			slide.classList.add("wedding-gallery__modal__image");
			slideimg.setAttribute("src", image.src);
			slide.appendChild(slideimg);
			slide.appendChild(load);
			slide.classList.add("loaded");
			viewport.appendChild(slide);
			page.classList.add("wedding-gallery__modal__pager__page");
			page.setAttribute("data-page", index);
			page.addEventListener("click", ()=>move(index), false);
			pager.appendChild(page);
		});
		close.addEventListener("click", closeModal, false);
		const pages = modal.querySelectorAll(".wedding-gallery__modal__pager__page");

		prev.style.display = "none";
		next.style.display = "block";
		prev.addEventListener("click", movePrev, false);
		next.addEventListener("click", moveNext, false);

		function closeModal(){
			modal.classList.remove("active");
			close.removeEventListener("click", closeModal);
			prev.removeEventListener("click", movePrev);
			next.removeEventListener("click", moveNext);
			setTimeout(()=>{
				if(!modal.classList.contains("active")){
					modal.classList.remove("open");
				}
			}, 500);
			if(window.isTouch){
				container.removeEventListener("touchstart", touchStartHandler);
				container.removeEventListener("touchmove", touchMoveHandler);
				container.removeEventListener("touchend", touchEndHandler);
				container.removeEventListener("touchleave", touchEndHandler);
			}
		}
		function movePrev(){
			move( Math.max(0, position-1) )
		}
		function moveNext(){
			move( Math.min(max-1, position+1) )
		}
		function move(num){
			position = num;
			prev.style.display = "block";
			next.style.display = "block";
			if(position <= 0){
				position = 0;
				prev.style.display = "none";
			}
			if(position >= max-1){
				position = max-1;
				next.style.display = "none";
			}
			modal.setAttribute("data-position", position);
			const negativeShiftSize = Math.min(Math.max(max-pagerAreaSize1,0), Math.max(0, position-Math.floor(pagerAreaSize1/2)));
			pages.forEach(page=>{
				page.classList.remove("mini");
				if( Math.abs(position-page.dataset.page)>2 ){
					page.classList.add("mini");
				}
				if(position < Math.floor(pagerAreaSize1/2)){
					if(page.dataset.page < pagerAreaSize1){
						page.classList.remove("mini");
					}
				}
				if(position > max-Math.floor(pagerAreaSize1/2)-1){
					if(page.dataset.page > max-pagerAreaSize1-1){
						page.classList.remove("mini");
					}
				}
				page.style.transform = "translateX("+(-100*negativeShiftSize)+"%)";
			});
		}

		if(window.isTouch){
			const container = modal.querySelector(".wedding-gallery__modal__container");
			const threshold = 50;
			let isDragging = null;
			let toNext = null;
			let startX,startY,moveX,moveY = 0;

			container.addEventListener("touchstart", touchStartHandler, {passive: true});
			container.addEventListener("touchmove", touchMoveHandler, {passive: false});
			container.addEventListener("touchend", touchEndHandler, {passive: true});
			container.addEventListener("touchleave", touchEndHandler, {passive: true});

			function touchStartHandler(e){
				e.stopPropagation();
				isDragging = false;
				if(e.changedTouches){
					startX = e.changedTouches[0].pageX;
					startY = e.changedTouches[0].pageY;
				}else{
					startX = e.pageX;
					startY = e.pageY;
				}
			}
			function touchMoveHandler(e){
				if(isDragging === null) return false;
				if(isDragging === true) e.preventDefault();
				if(e.changedTouches){
					moveX = e.changedTouches[0].pageX;
					moveY = e.changedTouches[0].pageY;
				}else{
					moveX = e.pageX;
					moveY = e.pageY;
				}
				if(isDragging === false){
					if(Math.abs(moveX - startX) > Math.abs(moveY - startY)){
						isDragging = true;
						if((moveX - startX) > 0){
							toNext = false;
						}else{
							toNext = true;
						}
					}else{
						isDragging = null;
					}
				}
			}
			function touchEndHandler(e){
				if(isDragging === true) {
					if(Math.abs(moveX - startX) > threshold){
						if(!toNext && (moveX - startX) > 0){
							//go to prev
							move( Math.max(0, position-1) )
						}
						if(toNext && (moveX - startX) < 0){
							//go to next
							move( Math.min(max-1, position+1) )
						}
					}
				}
				isDragging = null;
			}
		}

		move(position);
		modal.classList.add("open");
		requestAnimationFrame(()=>{requestAnimationFrame(()=>{
			modal.classList.add("active");
		})})
	}
	openModal(images,i){
		this.initModal(images, i);
	}
}